import integrationsApi from '@/api/integrations';
import {mutationTypes} from '@/store/modules/integrations/mutations';

export const actionsTypes = {
  translateIds: '[integrations] translate ids',
};

const actions = {
  [actionsTypes.translateIds](context, data) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.translateIdsStart);
      integrationsApi
        .translateIds(data)
        .then((response) => {
          context.commit(mutationTypes.translateIdsSuccess);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.translateIdsFailure);
          reject(result);
        });
    });
  },
};

export default actions;
